import { render } from "./AnnotationsListItem.vue?vue&type=template&id=5f5f0b5e&scoped=true"
import script from "./AnnotationsListItem.vue?vue&type=script&lang=js"
export * from "./AnnotationsListItem.vue?vue&type=script&lang=js"

import "./AnnotationsListItem.vue?vue&type=style&index=0&id=5f5f0b5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5f0b5e"]])

export default __exports__